import { TSearchServiceListQuery } from "../interface/TSearchServiceListQuery";

export const mapSearchServiceListQuery = (accountId: string): TSearchServiceListQuery => ({
    accountIds: [accountId],
});
